import React from 'react';

export const RenderOR = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => {
  return (
    <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
      <g style={{ transformOrigin: '0px 150px' }}>
          
        {/* Forma principale dell'occhiello */}
        <path 
          fillRule="evenodd" 
          vectorEffect="non-scaling-stroke" 
          d="M 89.525 76.535 L 25.002 66.749 L 25.002 69.386 L 25.002 75.144 L 25.002 79.956 L 25.002 83.763 L 25.002 86.518 L 25.002 88.184 L 25.002 88.743 L -152.43 88.743 L -189.69 110.25 L -346 110.25 L -346 0.024 L -346 -110.2 L -189.69 -110.2 L -152.43 -88.694 L 25.002 -88.694 L 25.002 -88.135 L 25.002 -86.469 L 25.002 -83.717 L 25.002 -79.909 L 25.002 -75.095 L 25.002 -69.338 L 25.002 -66.702 L 89.525 -76.485 C 111.274 -82.888 131.949 -92.491 150.871 -104.98 C 203.415 -139.67 273.51 -130.17 314.932 -82.756 C 356.356 -35.342 356.356 35.39 314.932 82.804 C 273.51 130.218 203.415 139.713 150.871 105.03 C 131.949 92.541 111.274 82.937 89.525 76.535 Z M 220.181 -71.219 C 180.836 -71.219 148.939 -39.322 148.939 0.024 C 148.939 39.37 180.836 71.268 220.181 71.268 C 259.528 71.268 291.424 39.37 291.424 0.024 C 291.424 -39.322 259.528 -71.219 220.181 -71.219 Z" 
          fill="#BFBFBF" 
          stroke="none" 
        />
        
        {/* Parte di plastica della crimpatura */}
        <path 
          fillRule="evenodd" 
          vectorEffect="non-scaling-stroke" 
          d="M -189.69 -110.2 L -189.69 0.024 L -189.69 110.25 L -346 110.25 L -346 0.024 L -346 -110.2 L -189.69 -110.2" 
          fill={color} 
          stroke="none" 
        />
        
        {/* Parte interna dettagliata della crimpatura */}
        <path 
          fillRule="evenodd" 
          vectorEffect="non-scaling-stroke" 
          d="M 25.002 -88.694 L 25.002 -88.135 L 25.002 -86.469 L 25.002 -83.717 L 25.002 -79.909 L 25.002 -75.095 L 25.002 -69.338 L 25.002 -66.702 L 25.002 -62.709 L 25.002 -55.29 L 25.002 -47.177 L 25.002 -42.227 L 25.002 -38.47 L 25.002 -29.278 L 25.002 -19.717 L 25.002 -9.909 L 25.002 0.024 L 25.002 9.958 L 25.002 19.766 L 25.002 29.326 L 25.002 38.517 L 25.002 42.276 L 25.002 47.226 L 25.002 55.339 L 25.002 62.757 L 25.002 66.749 L 25.002 69.386 L 25.002 75.144 L 25.002 79.956 L 25.002 83.763 L 25.002 86.518 L 25.002 88.184 L 25.002 88.743 L -152.43 88.743 L -152.43 0.024 L -152.43 -88.694 L 25.002 -88.694" 
          fill={color} 
          stroke="none" 
        />
        
        {/* Parte di collegamento angolata */}
        <path 
          fillRule="evenodd" 
          vectorEffect="non-scaling-stroke" 
          d="M -152.43 88.743 L -152.43 0.024 L -152.43 -88.694 L -189.69 -110.2 L -189.69 0.024 L -189.69 110.25 L -152.43 88.743" 
          fill={color} 
          stroke="none" 
        />
        
        {/* CONTORNI - con spessori variabili */}
        <g transform="matrix(0.988571, 0, 0, 0.988571, -0.000121, 0.04573)" stroke="#212529" strokeLinecap="round" strokeLinejoin="bevel" fill="none">
          {/* Contorni esterni spessi */}
          <path d="M -350 -0.022 L -350 -111.52" strokeWidth="8" />
          <path d="M -350 111.477 L -350 -0.022" strokeWidth="8" />
          <path d="M 25.291 -89.766 L 25.291 89.685" strokeWidth="8" />
          <path d="M 90.56 -77.417 L 25.291 -67.519" strokeWidth="8" />
          <path d="M 90.56 77.373 L 25.291 67.474" strokeWidth="8" />
          <path d="M 90.56 77.373 C 112.561 83.849 133.475 93.564 152.615 106.198" strokeWidth="8" />
          <path d="M 152.615 -106.24 C 133.475 -93.608 112.561 -83.893 90.56 -77.417" strokeWidth="8" />
          <path d="M 152.615 106.198 C 205.768 141.282 276.672 131.677 318.573 83.715 C 360.476 35.753 360.476 -35.797 318.573 -83.759 C 276.672 -131.72 205.768 -141.33 152.615 -106.24" strokeWidth="8" />
          <path d="M 294.793 -0.022 C 294.793 39.779 262.529 72.045 222.728 72.045 C 182.926 72.045 150.661 39.779 150.661 -0.022" strokeWidth="8" />
          <path d="M 150.661 -0.022 C 150.661 -39.823 182.926 -72.089 222.728 -72.089 C 262.529 -72.089 294.793 -39.823 294.793 -0.022" strokeWidth="8" />
          <path d="M -191.88 -111.52 L -350 -111.52" strokeWidth="8" />
          <path d="M -191.88 111.478 L -350 111.478" strokeWidth="8" />
          <path d="M -154.2 89.722 L -191.88 111.478" strokeWidth="8" />
          <path d="M -154.2 -89.766 L -191.88 -111.52" strokeWidth="8" />
          <path d="M 25.292 -89.766 L -154.2 -89.766" strokeWidth="8" />
          <path d="M 25.291 89.722 L -154.2 89.722" strokeWidth="8" />
          
          {/* Contorni interni sottili */}
          <path d="M -191.88 -111.52 L -191.88 111.428" strokeWidth="4" />
          <path d="M -154.2 89.685 L -154.2 -89.766" strokeWidth="4" />
        </g>
      </g>
    </g>
  );
};

